import { lazy } from "react";

// project imports
import { TargetAudience } from "../../../domain/entities/Campaign";
import { RoleLevel } from "../../../domain/entities/Role";
import MainLayout from "../theme/layout/MainLayout";
import Loadable from "../theme/widgets/Loadable";
import { ProtectedRoute } from "./util/ProtectedRoute";

// dashboard routing
const Users = Loadable(lazy(() => import("../pages/administrator/Users")));
const Metrics = Loadable(lazy(() => import("../pages/administrator/metrics/Metrics")));
const Organizations = Loadable(
  lazy(() => import("../pages/administrator/organizations/Organizations"))
);
const Configurations = Loadable(
  lazy(() => import("../pages/administrator/Configurations"))
);
const Payments = Loadable(
  lazy(() => import("../pages/administrator/payments/Payments"))
);
const Home = Loadable(lazy(() => import("../pages/dashboard-legacy/Default")));

const CampaignsParents = Loadable(
  lazy(() => import("../pages/requestor/campaigns/Campaigns"))
);

// ==============================|| MAIN ROUTING ||============================== //

const AdministratorRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <CampaignsParents targetAudience={TargetAudience.PARENTS} />
        </ProtectedRoute>
      ),
    },
    /*{
      path: "/",
      element: (
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      ),
    },*/
    {
      path: "metrics",
      element: (
        <ProtectedRoute level={RoleLevel.Administrator}>
          <Metrics />
        </ProtectedRoute>
      ),
    },
    {
      path: "users",
      element: (
        <ProtectedRoute level={RoleLevel.Administrator}>
          <Users />
        </ProtectedRoute>
      ),
    },
    {
      path: "organizations",
      element: (
        <ProtectedRoute level={RoleLevel.Administrator}>
          <Organizations />
        </ProtectedRoute>
      ),
    },
    {
      path: "configurations",
      element: (
        <ProtectedRoute level={RoleLevel.Administrator}>
          <Configurations />
        </ProtectedRoute>
      ),
    },
    {
      path: "payments",
      element: (
        <ProtectedRoute level={RoleLevel.Administrator}>
          <Payments />
        </ProtectedRoute>
      ),
    },
    {
      path: "image",
      element: (
        <ProtectedRoute>
          <Configurations />
        </ProtectedRoute>
      ),
    },
    {
      path: "home",
      element: (
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      ),
    },
  ],
};

export default AdministratorRoutes;
